module.exports = __webpack_public_path__ + "static/media/PTLEHoverFeature.330b1cb0.png";